import _ from 'lodash';

export function orderQuantityInBaseUnit({ unit, quantity, product }: { unit: { unit2: string }, quantity: number, product: any }): number {
  const sellingUnit = unit.unit2;
  const packingMode: { quantity: number, unit1: string, unit2: string }[] = _.get(product, 'packingMode', []);
  if(packingMode[0].unit1 == sellingUnit) return quantity;
  let baseQuantity = quantity;
  for(let i = 0; i < packingMode.length; i++) {
    if(packingMode[i].unit1 !== sellingUnit) {
      baseQuantity = baseQuantity * packingMode[i].quantity;
    }
    if(packingMode[i].unit2 == sellingUnit) {
      break;
    }
  }
  return baseQuantity;
}